var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:w-1/2"},[_c('Show',{attrs:{"client":_vm.client},on:{"show-service-requests":function($event){return _vm.$emit('show-service-requests')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }